import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Widgets */
import { Icon, ICON } from 'widget/icon'

/* Styles */
import './menu-item.css'

/* Button within dropdown widget */
export default class MenuItem extends Component {

  renderIcon() {
    const {
      icon,
      iconScheme,
    } = this.props
    if (icon) {
      return <Icon className="menu-icon" icon={ icon } circle={ true } size={ 24 } scheme={ iconScheme }/>
    }
    return null
  }

  getClassName() {
    let cls = []
    cls.push("dropdown-menu-item", "widget")
    if (this.props.style) cls.push(this.props.style)
    if (this.props.onClick) cls.push("interactive")
    return cls.join(" ")
  }

  render() {
    const {
      name,
      title,
      index,
      onClick,
      onClose
    } = this.props
    return (
      <li
        key={ index }
        className={ this.getClassName() }
        onClick={ (e) =>{ onClose(); onClick(e); } }
        title={ title }
      >
        { this.renderIcon() }
        <div>{ name }</div>
      </li>
    )
  }
}

MenuItem.propTypes = {
    icon: PropTypes.func,
    iconScheme: PropTypes.string,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    style: PropTypes.string,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    index: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/app/widget/dropdown-button/menu-item.jsx